import React from 'react';
import { DateRanger } from '../../../components/molecules/DateRanger/DateRanger';
import { Event } from '../EventListDetails.types';
import { TeaserListItem } from '../../../_lib/components/TeaserList';

type EventListTeaserItemProps = {
  event: Event;
};

export function EventListTeaserItem({ event }: EventListTeaserItemProps) {
  return (
    <TeaserListItem
      pageLinkUrl={event.pageLink.url}
      pageLinkName={event.pageLink.name}
      categories={event.categories}
      integrated={event.integrated}
      packState={event.packState}
      teaserImageUrl={event.teaserImage?.url}
      description={event.teaserText}
      date={
        <div className="teaser-list__date font-bold-14-19">
          <DateRanger
            start={event.eventStartDate}
            end={event.eventEndDate}
            multiDayEvent={event.multiDayEvent}
            allDayEvent={event.allDayEvent}
          />
        </div>
      }
    />
  );
}
